import {TweenMax, Linear} from 'gsap';
import AbstractView = require("./abstract/AbstractView");
import YTPlayer = require("../media/YTPlayer");

class PlayerView extends AbstractView {


    private ytPlayer: YTPlayer;
    private $closeBtn: JQuery;

    constructor(id: number, selector: JQuery) {
        super(id, selector);
    }


    reset(): void {
        if (this.ytPlayer) this.ytPlayer.stop();
    }

    init() {
        this.$closeBtn = this.getChildBySelector(".closeBtn");
        this.$closeBtn.on("click tap", (eventObject: JQueryEventObject) => {
            eventObject.preventDefault();
            this.transitionOut();
        });
        this.ytPlayer = new YTPlayer("ytPlayer", "", false, true, true);
    }

    public playVideo(id: string): void {
        this.ytPlayer.changeVideo(id);
        this.transitionIn();
    }

    public stopVideo(): void {
        this.transitionOut();
    }

    public transitionIn(): void {

        TweenMax.killTweensOf(this);
        this.$template.css("display", "block");
        TweenMax.to(this.$template, 1, {
            delay: 0.3,
            alpha: 1,
            ease: Linear.easeOut,
            onComplete: this.onTransitionComplete.bind(this),
            onCompleteParams: ["IN_COMPLETED"]
        });
    }

    public transitionOut(): void {
        TweenMax.killTweensOf(this);
        TweenMax.to(this.$template, 1, {
            alpha: 0,
            ease: Linear.easeOut,
            onComplete: this.onTransitionComplete.bind(this),
            onCompleteParams: ["OUT_COMPLETED"]
        });
    }

    public onTransitionComplete(type: string): void {

        if (type == "IN_COMPLETED") {

        }
        if (type == "OUT_COMPLETED") {
            this.reset();
            this.$template.css("display", "none");
        }
    }

}

export = PlayerView;